/* eslint-disable react/prop-types */
import { Icon, Tooltip } from "@mui/material";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";

const getRows = (data, accion, finalizado) => {
  const rows = [];
  if (data) {
    data.forEach((item) => {
      if (!item.dateDel) {
        rows.push({
          nombre: (
            <SoftBox>
              <SoftTypography verticalAlign="text-top" variant="subtitle2" fontWeight="bold">
                {item?.Nombre ? item?.Nombre : "-"}
              </SoftTypography>
            </SoftBox>
          ),
          talle: (
            <SoftBox>
              <SoftTypography verticalAlign="text-top" variant="subtitle2" fontWeight="bold">
                {item?.TALLE ? item?.TALLE : "-"}
              </SoftTypography>
            </SoftBox>
          ),
          colo: (
            <SoftBox>
              <SoftTypography verticalAlign="text-top" variant="subtitle2" fontWeight="bold">
                {item?.COLOR ? item?.COLOR : "-"}
              </SoftTypography>
            </SoftBox>
          ),
          codProv: (
            <SoftBox>
              <SoftTypography verticalAlign="text-top" variant="subtitle2" fontWeight="bold">
                {item?.CodProv ? item?.CodProv : "-"}
              </SoftTypography>
            </SoftBox>
          ),
          cantidad: (
            <SoftBox>
              <SoftTypography verticalAlign="text-top" variant="subtitle2" fontWeight="bold">
                {item?.Cantidad ? Math.abs(item?.Cantidad) : "-"}
              </SoftTypography>
            </SoftBox>
          ),
          accion: (
            <SoftBox mr={2} display="flex" flexDirection="row">
              {!finalizado && item.Estado !== "finalizado " && (
                <Tooltip title="Quitar artículo" placement="top">
                  <Icon
                    fontSize="small"
                    sx={{
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      accion("borrar", item);
                    }}
                  >
                    cancel
                  </Icon>
                </Tooltip>
              )}
            </SoftBox>
          ),
        });
      }
    });
  }

  return rows;
};

const columns = [
  { name: "codProv", desc: "Cod. Prov.", align: "center" },
  { name: "nombre", desc: "Nombre", align: "left" },
  { name: "talle", desc: "Talle", align: "center" },
  { name: "colo", desc: "Color", align: "center" },
  { name: "cantidad", desc: "Cantidad", align: "center" },
  { name: "accion", desc: " ", align: "center", width: "1%", noOrder: true },
];

export default { columns, getRows };
